/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-20 09:06:57
 * @FilePath: \hlweb2.0\src\pages\Solution\common\Banner\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { JumpApply } from "../../../../components/Jump";
import "./index.scss";
function Banner({ active }) {
  const history = useHistory()
  const { t } = useTranslation();
  const productList = t("productList", { returnObjects: true });
  const click = () => {
    history.push("/apply");
  };
  return (
    <div className="banner_side">
      <div className="banner_con">
        <div className="banner_left">
          <div className="banner-name">{productList[active].con1}</div>
          <div className="banner-til">{productList[active].con2}</div>
          <div className="banner-del">
              {productList[active].con3List.map((item, index) => {
                return <div>{item}</div>;
              })}
          </div>
          <div className="banner-but" onClick={() => click()}>
            {productList[active].linked}
          </div>
        </div>
        <div className="banner_right">
          <img src={productList[active].imgUrl} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Banner;
